export const NoIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.35556 7.49641L14.8133 1.0324C14.9272 0.917906 14.9911 0.762932 14.991 0.601419C14.9909 0.439905 14.9268 0.285017 14.8127 0.170679C14.5844 -0.0565108 14.1822 -0.057658 13.9516 0.171827L7.49557 6.63584L1.03729 0.170106C0.807801 -0.0565107 0.405628 -0.0553634 0.177291 0.171253C0.120615 0.227703 0.0757494 0.294875 0.0453123 0.36885C0.0148752 0.442825 -0.000523872 0.522121 1.35993e-05 0.602111C1.35993e-05 0.765046 0.063122 0.917653 0.177291 1.03067L6.635 7.49584L0.177864 13.9616C0.0639168 14.0762 0.000104844 14.2314 0.000427507 14.3931C0.00075017 14.5547 0.0651812 14.7097 0.179586 14.8239C0.290312 14.9334 0.446936 14.9966 0.608722 14.9966H0.612165C0.774525 14.996 0.931149 14.9323 1.03958 14.8216L7.49557 8.35756L13.9538 14.8233C14.068 14.9369 14.2206 15 14.3824 15C14.4624 15.0002 14.5417 14.9846 14.6156 14.9541C14.6896 14.9236 14.7568 14.8788 14.8133 14.8222C14.8699 14.7656 14.9147 14.6985 14.9452 14.6245C14.9758 14.5505 14.9913 14.4713 14.9911 14.3913C14.9911 14.2289 14.928 14.0757 14.8133 13.9627L8.35556 7.49641Z"
      fill="#F70000"
    />
  </svg>
);
